import { GENDER_FEMALE, GENDER_MALE } from "shared/constants/index.js";

export const EMAIL_REGEXP =
  // eslint-disable-next-line
  /^(([^<>()\[\]\\.,;:%\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const SUBMITTED = "SUBMITTED";
export const CONST_EMAIL_MAX_SYMBOLS = 255;
export const MAX_PASSWORD_LENGTH = 255;
export const MIN_PASSWORD_LENGTH = 5;

export const TOKEN_KEY = "auth_key";

export const FIRST_STEP_REGISTER_FORM = 1;
export const SECOND_STEP_REGISTER_FORM = 2;

export const getErrorEventsName = (
  errorText: string,
  type: string,
  page: string
): string => {
  const errorEvents: Record<string, string> = {
    empty: `err_${page}_${type}_name_noname`,
    too_short: `err_${page}_${type}_name_shortname`,
    invalid_chars: `err_${page}_${type}_name_symbolname`,
  };

  return errorEvents[errorText];
};

export const errorEventsBirthday = {
  M: "err_lnd_sign_up_age_onlymonth",
  D: "err_lnd_sign_up_age_onlyday",
  Y: "err_lnd_sign_up_age_onlyyear",
  MD: "err_lnd_sign_up_age_onlydaymonth",
  DY: "err_lnd_sign_up_age_onlydayyear",
  MY: "err_lnd_sign_up_age_onlymonthyear",
};

export const errorEventsBirthdayAbout = {
  M: "err_home_p_sign_up_google_birthday_onlymonth",
  D: "err_home_p_sign_up_google_birthday_onlyday",
  Y: "err_home_p_sign_up_google_birthday_onlyyear",
  MD: "err_home_p_sign_up_google_birthday_onlydaymonth",
  DY: "err_home_p_sign_up_google_birthday_onlydayyear",
  MY: "err_home_p_sign_up_google_birthday_onlymonthyear",
};

export const getErrorEventEmail = (
  errorText: string,
  type: string,
  page: string
): string => {
  const errorEvents: Record<string, string> = {
    "Field cannot be empty.": `err_${page}_${type}_email_noemail`,
    "Your email address is not valid. Please, check it.": `err_${page}_${type}_email_wrongemail`,
    "This email address has already been used.": `err_${page}_${type}_email_againemail`,
  };

  return errorEvents[errorText];
};

export const getErrorEventPassword = (
  errorType: string,
  type: string,
  page: string
): string => {
  const errorEvents: Record<string, string> = {
    empty: `err_${page}_${type}_password_nopassword`,
    too_short: `err_${page}_${type}_password_shortpassword`,
    empty_repeat: `err_lnd_${type}_password2_nopassword`,
    not_matches: `err_lnd_${type}_password2_wrongpassword`,
  };

  return errorEvents[errorType];
};

export const eventsMapGender = {
  [GENDER_MALE]: "cl_home_p_sign_up_1_i_am_man",
  [GENDER_FEMALE]: "cl_home_p_sign_up_1_i_am_woman",
};

export const eventsMapGenderAbout = {
  [GENDER_MALE]: "cl_home_p_sign_up_google_i_am_man",
  [GENDER_FEMALE]: "cl_home_p_sign_up_google_i_am_woman",
};

export const termsLinks = [
  { key: "link1", href: "/terms-of-use/" },
  { key: "link2", href: "/privacy-policy/" },
  { key: "link3", href: "/cookie-policy/" },
  { key: "link4", href: "/billing-policy/" },
  { key: "link5", href: "/refund-policy/" },
  { key: "link6", href: "/consent-policy/" },
];

export const ERROR_EMAIL_ALREADY_USED =
  "This email address has already been used.";
